const initialState = {
    allCategory: [],
   worksheet:null,
    loading: true,
    item:[],
    current:null
   
  
  };

  const categoryReducer = (state = initialState, action) => {
    
    switch (action.type) {
      case "SET_CURRENT":
       
        return {
          ...state,
          current: action.data,
          loading: action.loading,
        };
        case "CLEAR_CURRENT":
        
          return {
            ...state,
            current: null,
            loading: action.loading,
          };
      case "GET_CAT":
        return {
          ...state,
          allCategory: action.data,
          loading: action.loading,
        };
        case "GET_WORKSHEET":
    
        return {
          ...state,
         item:action.data,
          loading: action.loading,
        };
        case "UPDATE_THEME":
          return {
            ...state,
            allCategory: action.data
          };
      case "UPDATE":
        return {
          ...state,
          worksheet: action.data
        };
        case "ADD_PAPERS":
         // console.log(action.papers);
          return {
            ...state,
            worksheet: action.papers
          };
         
      default:
        return state;
    }
  };
  
  export default categoryReducer;
  